<template>
  <div class="detail-content">
    <div class="detail-content-title">
      <h1>【号外】朗拓健康携“互联网+医疗健康服务闭环建设之处方共享”解决方案同步亮相多个学术高峰论坛</h1>
      <h4>2018-10-29<span>朗拓健康</span></h4>
    </div>
    <div class="detail-content-main">
      <p>
        2018 中国研究型医院学会移动医疗专业委员会年会暨第五届"互联网+医疗"学术高峰论坛于2018年10月26日-28日在江苏南京成功召开。
      </p>
      <p>
        “中国数字医学前沿论坛—互联网+医疗服务模式创新及网络安全”于2018年10月26日-28日在福建省福州市同步举办。
      </p>
      <p>
        朗拓健康携“互联网+医疗健康服务闭环建设之处方共享”全解决方案强势亮相双会。
      </p>
      <img src="../../assets/images/trend3/1.png"/>
      <p>
        第五届全国“互联网+医疗”学术高峰论坛以“创新驱动，科技引领”为主题，设有主题报告、圆桌论坛、成果转化、产品展示四种交流形式，江苏朗拓健康科技有限公司销售部总经理仇剑晶在青年论坛上发表了精彩演讲，现场“干货”十足，在场嘉宾连连点头，称赞有加。
      </p>
      <img src="../../assets/images/trend3/2.png"/>
      <p>
        朗拓健康是以药迅处方共享平台为核心产品，提供“互联网+医疗健康便民服务”全生态解决方案。力求联通处方共享平台，构建处方闭环体系；通过线上商城，把药房搬上云端；凭借多维度的安全服务体系，让患者就医购药更放心。
      </p>
      <img src="../../assets/images/trend3/3.png"/>
      <p>
        会场当天，南京与福州会场展台吸引了医疗信息化领域大咖驻足参观，他们与现场的技术人员交流产品技术，分享经验，场面十分火爆。
      </p>
      <img src="../../assets/images/trend3/4.png"/>

    </div>
  </div>
</template>

<script  type="text/javascript">
export default {
  data () {
    return {
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/trend/Trend3.vue